import React from 'react';

const AWS_Lambda = () => {
  return (
    <div>
      <h1>AWS_Lambda</h1>
      <p>This is the AWS_Lambda component.</p>
    </div>
  );
};

export default AWS_Lambda;
